import { TextField as MuiTextField } from '@mui/material';
import { DesktopDatePicker, DesktopDatePickerProps } from '@mui/x-date-pickers';
import { isValid } from 'date-fns';
import { FieldPath, FieldValues } from 'react-hook-form';

import {
    ControlledTextFieldProps, addValidationRule, isNotFutureDate, isNotPastDate, isValidDate,
    useControlledTextFieldProps
} from '.';


export type DateFieldProps<
    TFieldValues extends FieldValues,
    TName extends FieldPath<TFieldValues>
> = ControlledTextFieldProps<TFieldValues, TName> & {
    pickerProps?: Partial<DesktopDatePickerProps<Date, Date>>;
};

export function DateField<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({ pickerProps, ...props }: DateFieldProps<TFieldValues, TName>) {
    const { onChange, value, ...textFieldProps } = useControlledTextFieldProps<TFieldValues, TName>({
        ...props,
        rules: addValidationRule(props.rules, {
            isValidDate,
            ...(pickerProps?.disableFuture && { isNotFutureDate }),
            ...(pickerProps?.disablePast && { isNotPastDate })
        })
    });

    return (
        <DesktopDatePicker<Date>
            {...pickerProps}
            value={value}
            inputFormat="MM/dd/yyyy"
            onChange={date => onChange(
                isValid(date)
                    ? date!.toISOString()
                    : date
            )}
            renderInput={params => (
                <MuiTextField
                    {...params}
                    {...textFieldProps}
                    inputRef={params.inputRef}
                    inputProps={{
                        ...textFieldProps.inputProps,
                        ...params.inputProps
                    }}
                />
            )}
        />
    );
}
